var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2428 8.43708C18.4016 8.3489 18.5 8.18159 18.5 8C18.5 7.81842 18.4016 7.65111 18.2428 7.56292L15.9605 6.29496C11.464 3.79689 6.72391 1.76488 1.81421 0.2306L1.14914 0.0227641C0.997318 -0.0246794 0.831984 0.00294204 0.703833 0.0971586C0.57568 0.191375 0.5 0.340945 0.5 0.500004V6.25C0.5 6.51593 0.708158 6.73533 0.97372 6.74931L1.98336 6.80245C4.44497 6.93201 6.89156 7.26588 9.29788 7.80062L9.53619 7.85358C9.5892 7.86536 9.61217 7.88704 9.62495 7.90424C9.64107 7.92595 9.65365 7.95939 9.65365 8C9.65365 8.04062 9.64107 8.07406 9.62495 8.09577C9.61217 8.11297 9.5892 8.13465 9.53619 8.14643L9.2979 8.19938C6.89157 8.73413 4.44496 9.068 1.98334 9.19756L0.97372 9.25069C0.708158 9.26467 0.5 9.48407 0.5 9.75V15.5C0.5 15.6591 0.575679 15.8086 0.703832 15.9029C0.831983 15.9971 0.997318 16.0247 1.14914 15.9772L1.81422 15.7694C6.72391 14.2351 11.464 12.2031 15.9605 9.70505L18.2428 8.43708Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.2d63dfef24f9c211b140442958a263a0.svg";
export { ForwardRef as ReactComponent };